import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props} />
  );
}

// Page-level skeleton for full page loading
function PageSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header Skeleton */}
      <div className="border-b border-border bg-card/50 h-14 px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="w-8 h-8 rounded-lg" />
          <Skeleton className="w-24 h-6" />
        </div>
        <Skeleton className="w-8 h-8 rounded-full" />
      </div>
      
      {/* Content Skeleton */}
      <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">
        <Skeleton className="w-48 h-8" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-3/4 h-4" />
        
        <div className="space-y-4 pt-4">
          <Skeleton className="w-full h-32 rounded-xl" />
          <Skeleton className="w-full h-32 rounded-xl" />
          <Skeleton className="w-full h-32 rounded-xl" />
        </div>
      </div>
    </div>
  );
}

// Card skeleton for list items
function CardSkeleton() {
  return (
    <div className="bg-card border border-border rounded-xl p-4 space-y-3">
      <div className="flex items-center gap-3">
        <Skeleton className="w-12 h-12 rounded-lg" />
        <div className="flex-1 space-y-2">
          <Skeleton className="w-3/4 h-4" />
          <Skeleton className="w-1/2 h-3" />
        </div>
      </div>
    </div>
  );
}

// List skeleton for multiple cards
function ListSkeleton({ count = 5 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}

// Stats skeleton
function StatsSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-card border border-border rounded-xl p-4 text-center space-y-2">
          <Skeleton className="w-6 h-6 mx-auto rounded-full" />
          <Skeleton className="w-12 h-6 mx-auto" />
          <Skeleton className="w-16 h-3 mx-auto" />
        </div>
      ))}
    </div>
  );
}

export { Skeleton, PageSkeleton, CardSkeleton, ListSkeleton, StatsSkeleton }
